import { useMount } from 'react-use';

export const useCannySdk = () => {
    useMount(() => {
        (function (w: any, d: any, i: any, s: any) {
            function l() {
                if (!d.getElementById(i)) {
                    let f: any = d.getElementsByTagName(s)[0],
                        e: any = d.createElement(s);

                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                    (e.type = 'text/javascript'),
                        (e.async = !0),
                        (e.src = 'https://canny.io/sdk.js'),
                        f.parentNode.insertBefore(e, f);
                }
            }

            if ('function' != typeof w.Canny) {
                const c: any = function (...args: any[]) {
                    c.q.push(args);
                };

                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                (c.q = []),
                    (w.Canny = c),
                    'complete' === d.readyState
                        ? l()
                        : w.attachEvent
                          ? w.attachEvent('onload', l)
                          : w.addEventListener('load', l, !1);
            }
        })(window, document, 'canny-jssdk', 'script');
    });
};
